<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_789_57494)">
      <path
        d="M10 0C15.527 0 20 4.4725 20 10C20 15.5269 15.5275 20 10 20C4.47301 20 0 15.5275 0 10C0 4.47309 4.4725 0 10 0ZM8.97309 13.9696C8.97309 14.2855 9.43379 14.6014 9.9998 14.6014C10.5921 14.6014 11.0133 14.2855 11.0133 13.9696V8.95445C11.0133 8.5859 10.5921 8.33574 9.9998 8.33574C9.43379 8.33574 8.97309 8.5859 8.97309 8.95445V13.9696ZM9.99977 7.12484C10.6053 7.12484 11.0791 6.6773 11.0791 6.17707C11.0791 5.67687 10.6052 5.2425 9.99977 5.2425C9.40742 5.2425 8.93352 5.67687 8.93352 6.17707C8.93352 6.6773 9.40746 7.12484 9.99977 7.12484Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_789_57494">
        <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0)" />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'IconInfoFlat',
});
</script>
